import { NewTicketData } from '../redux/slices/tickets';

export function adapterOldTicketToNewFormat(ticket: any): NewTicketData {
	const formattDateToMillis = (date: any) => {
		if (date < 9999999999) {
			return date * 1000;
		} else {
			return date;
		}
	};
	return {
		uid: ticket.id,
		ticketId: ticket.id,
		title: ticket.subject,
		description: ticket.description,
		shortDescription: ticket.subject,
		group: ticket.group.id || '',
		type: ticket.type,
		status: ticket.status || ticket.state.name,
		email: '',
		user: {
			name: ticket.creationUser.name || 'Desconhecido',
			uid: ticket.creationUser.id || '',
		},
		number: String(ticket.number),
		creationDate: formattDateToMillis(ticket.creationDate),
		lastChangeDate: formattDateToMillis(ticket.lastChangeDate),
		deadline: formattDateToMillis(ticket.deadline),
		responsible: ticket.responsible
			? {
					name: ticket.responsible.name,
					uid: ticket.responsible.id || '',
			  }
			: undefined,
		product: undefined,
		associatedUser: undefined,
		razao: '',
		ccEmails: [],
		cnpj: '',
		phone: '',
		operationStatus: 'Operação consegue trabalhar',
		viewDetectorUid: undefined,
	};
}
